export const MFA_INPUT_FORM = 'MFA_INPUT_FORM';
